<div class="screen screen--split">

  <app-theme-header></app-theme-header>

  <h1 class="screen__title">Terms &amp;<br />Conditions<br />Privacy Policy</h1>

  <!-- The legal copy lives in the page template so the default modal and every theme share
       one source. This only positions and styles it. -->
  <div class="screen__body">
    <ng-container [ngTemplateOutlet]="host.termsBody"></ng-container>
  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.onDecline()">BACK</button>
    <button type="button" class="outline-button" (click)="host.onAccept()">AGREE</button>
  </div>

</div>
